module.exports = __webpack_public_path__ + "static/hand-15851c72618e70846205b52b823a9080.png";